export enum CommentOrderByInput {
  id_ASC = "metadata_id__ASC",
  id_DESC = "metadata_id__DESC",
  timestamp_ASC = "timestamp__ASC",
  timestamp_DESC = "timestamp__DESC",
  user_id_ASC = "user_id__ASC",
  user_id_DESC = "user_id__DESC"
}
